import type React from "react";

import { CopyIcon } from "@phosphor-icons/react";

import { toastError, toastSuccess } from "@alpacahq/ui/old";

export interface CopyButtonProps {
  value: string;
  ariaLabel?: string;
  successMessage?: string;
  errorMessage?: string;
  iconSize?: number;
  className?: string;
  iconClassName?: string;
}

export const CopyButton = ({
  value,
  ariaLabel = "Copy",
  successMessage = "Copied to clipboard",
  errorMessage = "Failed to copy",
  iconSize = 16,
  className,
  iconClassName = "text-gray-500 hover:text-gray-700",
}: CopyButtonProps) => {
  const onClick = async (event: React.MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();
    if (!value) {
      return;
    }
    try {
      await navigator.clipboard.writeText(value);
      toastSuccess(successMessage);
    } catch {
      toastError(errorMessage);
    }
  };

  return (
    <button
      type="button"
      onClick={onClick}
      aria-label={ariaLabel}
      className={className}
    >
      <CopyIcon size={iconSize} className={iconClassName} />
    </button>
  );
};
